<template>
<section>
	<div class="d-flex flex-row align-items-center justify-content-between">
		<h3 class="mb-0">Labour</h3>

		<div v-if="!isFinalized">
			<button type="button" class="btn btn-success" v-on:click="addLine">
				<i class="fa fa-plus"></i>
				Add Labour Line
			</button>
		</div>
	</div>

	<table-list
		record-name="Labour Line"
		:fields="[
			{label: 'Charge Out Group',key:'chargeOutGroupName'},
			{label: 'Rate',key:'rate',align:'right'},
			{label: 'Crew',key:'crew',align:'right'},
			{label: 'Hours',key:'hrs',align:'right'},
			{label: 'Total',key:'lineTotal',align:'right'}
		]"
		:records="localLabourQuoted"
		:has-delete="!isFinalized"
		:has-edit="!isFinalized"
		:simple-delete="true"
		:hide-record-count="true"
		:sortable="true"
		v-on:edit="editLabourLine"
		v-on:delete="deleteObject($event,quoteObjectResource)">

		<div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-2 mt-2">
			<info-box label="Material Labour Total (hrs)" :value="materialLabourTotal.toFixed(2)"></info-box>
			<info-box label="Labour Total" :value="'$ '+quoteLabourTotal"></info-box>
		</div>

	</table-list>

	<div>
		<info-box class="float-right"
			label="Total Hours" 
			:value="totalLabourHours.toFixed(2)">
		</info-box>
		<div style="clear: both;"></div>
	</div>

	<modal-dialog :modal-visible="labourModal.visible"
		title="Add Labour Line"
		confirm-button-text="Save"
		v-on:closeModal="labourModal.visible = false"
		v-on:confirm="saveObject(labourModal,false,quoteObjectResource)">

		<field label="Charge Out Group"
			col-class="col-md-4"
			:params="{type:'select',options:chargeOutGroupOptions}"
			v-model="labourModal.payload.group_id"
			v-on:change="chargeOutGroupSelected">
		</field>

		<field label="Rate"
			col-class="col-md-4"
			:params="{type:'number',step:0.01}"
			v-model="labourModal.payload.rate"
			v-on:input="calcLineTotal">
		</field>

		<field label="Crew"
			col-class="col-md-4"
			:params="{type:'number',step:0.25}"
			v-model="labourModal.payload.crew"
			v-on:input="calcLineTotal">
		</field>

		<field label="Hrs Per Crew"
			col-class="col-md-4"
			:params="{type:'number',step:0.25}"
			v-model="labourModal.payload.hrs"
			v-on:input="calcLineTotal">
		</field>

		<field label="Total"
			col-class="col-md-4"
			:readonly="true"
			v-model="labourModal.payload.lineTotal">
		</field>

	</modal-dialog>
</section>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import InfoBox from "@/components/InfoBox"
import FormGroup from "@/components/FormGroup"

import InvoiceMixins from "@/mixins/InvoiceMixins"

export default {
	name: "QuoteLabourSection",
	components: {
		TableList,
		ModalDialog,
		Field,
		InfoBox,
		FormGroup
	},
	mixins: [InvoiceMixins],
	props: ["labourQuoted","quoteId","materialLabourTotal","quoteObjectResource","quoteResource","isFinalized"],
	data() {
		return {
			chargeOutGroups: [],
			labourModal: {
				visible: false,
				isEdit: false,
				payload: {
					group_id: null,
					hrs: "",
					rate: null,
					crew:1,
					lineTotal: 0,
					type: "Labour",
					chargeOutGroupName: "",
					invoice_id: null
				}
			}
		}
	},
	computed: {
		quoteLabourTotal() {
			return this.localLabourQuoted.reduce((acc,item) => acc + +item.lineTotal,0).toCurrency()
		},
		localLabourQuoted() {
			let vm = this

			return this.labourQuoted.map(item => {
				let lineTotal = +item.hrs * +item.rate * +item.crew
				item.lineTotal = lineTotal.toCurrency()

				return item
			})
		},
		chargeOutGroupOptions() {
			return this.optionify(this.chargeOutGroups.map(group => {
				group.labelWithRate = group.label + " ($"+group.charge_out_rate+"/hr)"
				return group
			}),"labelWithRate")
		},
		labourModalLineTotal() {
			let total = +this.labourModal.hrs * this.labourModal.rate

			return total.toCurrency()
		},
		totalLabourHours() {
			return this.localLabourQuoted.reduce((acc,item) => acc + +item.hrs,0)
		}
	},
	methods: {
		addLine() {
			this.labourModal.isEdit = false
			this.labourModal.visible = true
			this.labourModal.payload = {
				group_id: null,
				hrs: "",
				rate: null,
				crew:1,
				lineTotal: 0,
				type: "Labour",
				chargeOutGroupName: "",
				invoice_id: this.quoteId
			}
		},
		totalCrew(labourLines) {
			if (labourLines.length == 0)
				return 0

			return labourLines.reduce((acc,line) => acc + +line.crew,0)
		},
		materialLabourTotalChange(hrs) {
			let vm = this

			let payload = {
				id: this.quoteId,
				quote_labour_total: hrs
			}

			this.postData(this.quoteResource+"/save",payload)

			let items = vm.cloneObj(this.localLabourQuoted)

			this.overwriteObjects(items,[],vm.quoteObjectResource).then(response => {
				let objs = items.map(item => {
					let itemFields = {
						rate: item.rate,
						hrs: +item.hrs,
						crew: +item.crew,
						lineTotal: +item.lineTotal,
						group_id: item.group_id,
						id: item.id,
						chargeOutGroupName: item.chargeOutGroupName
					}

					return {
						field_values_json: JSON.stringify(itemFields),
						invoice_id: item.invoice_id,
						type: "Labour"
					}
				})

				vm.overwriteObjects([],objs,vm.quoteObjectResource)
			})
		},
		editLabourLine(record) {
			let vm = this

			this.labourModal.visible = true
			this.labourModal.payload = JSON.parse(JSON.stringify(record))
			this.labourModal.isEdit = true
		},
		calcLineTotal() {
			let vm = this

			this.$nextTick(() => {
				let lineTotal = +vm.labourModal.payload.hrs * +vm.labourModal.payload.rate * +vm.labourModal.payload.crew

				vm.labourModal.payload.lineTotal = lineTotal.toCurrency()
			})
		},
		chargeOutGroupSelected(value) {
			let group = this.chargeOutGroups.find(gr => gr.id == value)

			if (group) {
				this.labourModal.payload.rate = group.charge_out_rate
				this.labourModal.payload.chargeOutGroupName = group.label
			}
		},
		/*
		saveLabourLines(obj,action) {
			let vm = this

			vm.$nextTick(() => {

				let newObjects = vm.localLabourQuoted.map(item => {

					let hrs = +vm.localMaterialLabourTotal / totalCrew * +item.crew

					hrs = hrs.toFixed(2)

					let objPayload = {
						type: "Labour",
						field_values_json: JSON.stringify({
							rate: item.rate,
							hrs: item.hrs,
							total: item.total,
							crew: item.crew,
							group_id: item.group_id,
							chargeOutGroupName: item.chargeOutGroupName,
							id: item.id
						})
					}

					if (vm.quoteObjectResource == 'ServiceInvoiceObject')
						objPayload.invoice_id = vm.quoteId
					else if (vm.quoteObjectResource == 'JobChangeQuoteObject')
						objPayload.quote_id = vm.quoteId

					return objPayload
				})

				if (action == 'add' || action == 'edit') {
					let group = vm.chargeOutGroups.find(gr => gr.id == obj.group_id)

					let chargeOutGroupName = ""
					if (group)
						chargeOutGroupName = group.label

					let hrs = +vm.localMaterialLabourTotal / totalCrew * +obj.crew

					if (vm.labourModal.isEdit) {
						let index = newObjects.findIndex(obj2 => {
							let fields = JSON.parse(obj2.field_values_json)

							if (fields.id == obj.id)
								return true
						})

						if (index >= 0) {
							newObjects[index].field_values_json = JSON.stringify({
								rate: obj.rate,
								hrs: hrs.toFixed(2),
								total: obj.total,
								crew: obj.crew,
								group_id: obj.group_id,
								chargeOutGroupName: chargeOutGroupName,
								id: obj.id
							})
						}
						
					}
					else {

						let objPayload = {
							type: "Labour",
							field_values_json: JSON.stringify({
								rate: obj.rate,
								hrs: hrs.toFixed(2),
								total: obj.total,
								crew: obj.crew,
								group_id: obj.group_id,
								chargeOutGroupName: chargeOutGroupName,
								id: obj.id
							})
						}

						if (vm.quoteObjectResource == 'ServiceInvoiceObject')
							objPayload.invoice_id = vm.quoteId
						else if (vm.quoteObjectResource == 'JobChangeQuoteObject')
							objPayload.quote_id = vm.quoteId

						newObjects.push(objPayload)
					}
				}
				else if (action == 'delete') {

					let index = newObjects.findIndex(obj2 => {
							let fields = JSON.parse(obj2.field_values_json)

							if (fields.id == obj.id)
								return true
						})

					if (index >= 0)
						newObjects.splice(index,1)

				}

				vm.overwriteObjects(vm.localLabourQuoted,newObjects,vm.quoteObjectResource).then(response =>{
					if (response.success) 
						vm.labourModal.visible = false
				})
			})
		},*/
		fetchData() {
			let vm = this

			let promises = [
				this.getJSON("ClassificationGroup/get",{},true)
			]

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[0].success) {
					vm.chargeOutGroups = responses[0].data
				}
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>
